<template>
    <v-navigation-drawer
        v-model="openedSidebar"
        class="navigation-drawer"
        color="#fff"
        fixed
        :temporary="temporary"
        :permanent="!temporary"
        disable-resize-watcher
        mobile-breakpoint="768"
    >
        <v-list class="name-wrapper">
            <v-list-item class="name">
                <div class="name">
                    <div class="name-content pr-3">
                        <span class="comparison-symbol">&#60;</span>
                        <span>Dimitris</span>
                    </div>
                    <div class="name-content">
                        <span> Karageorgos</span>
                        <span class="symbol ml-1">/</span>
                        <span class="comparison-symbol">&#62;</span>
                    </div>
                </div>
            </v-list-item>
        </v-list>
        <v-divider />
        <v-list
            nav
        >
            <v-list-item-group v-model="selectedMenuItemIndex" class="list" active-class="active-class">
                <v-list-item v-for="item in menu" :key="item.title" @click="menuItemClick(item)">
                    <div class="list-item">
                        <v-img class="menu-img" :src="item.icon" /> {{ item.title }} </div>
                </v-list-item>
            </v-list-item-group>
        </v-list>
    </v-navigation-drawer>
</template>

<script>
    export default {
        name: 'Sidebar',
        props: {
            temporary: {
                Boolean,
                default: () => { return false }
            },
            view: {
                Boolean,
                default: () => { return false }
            }
        },
        data() {
            return {
                openedSidebar: false,
                selectedMenuItemIndex: 1,
                menu: [
                    {
                        title: 'Home',
                        elementId: 'home',
                        path: '/home',
                        icon: require('@/assets/icons/home.svg')
                    },
                    {
                        title: 'About Me',
                        elementId: 'about',
                        path: '/about',
                        icon: require('@/assets/icons/human.svg')
                    },
                    {
                        title: 'Technologies',
                        elementId: 'technologies',
                        path: '/technologies',
                        icon: require('@/assets/icons/tech.svg')
                    },
                    // {
                    //     title: 'Portfolio',
                    //     elementId: 'portfolio',
                    //     path: '/portfolio',
                    //     icon: require('@/assets/icons/portofolio.svg')
                    // },
                    {
                        title: 'Contact',
                        elementId: 'contact',
                        path: '/contact',
                        icon: require('@/assets/icons/contact.svg')
                    }
                ]
            }
        },
        watch: {
            view: {
                handler(old, newval) {
                    this.openedSidebar = !this.openedSidebar
                }
            }
        },
        mounted() {
            const observer = new IntersectionObserver((entries) => { this.onElementsView(entries) }, { threshold: [0.3] })
            this.menu.forEach(item => observer.observe(document.querySelector('#' + item.elementId)))
        },
        methods: {
            onElementsView(entries) {
                if (!entries[0].isIntersecting) {
                    return
                }
                this.selectedMenuItemIndex = this.menu.findIndex(item => item.elementId === entries[0].target.id)
                if (this.menu[this.selectedMenuItemIndex].path && this.$route.path !== this.menu[this.selectedMenuItemIndex].path) {
                    this.$router.push({ path: this.menu[this.selectedMenuItemIndex].path })
                }
            },
            menuItemClick(item) {
                this.$vuetify.goTo('#' + item.elementId)
                this.$router.push({ path: item.path })
            }
        }
    }
</script>

<style scoped>

.name-content {
    display: flex;
    align-items: center;
    justify-content: center;
    max-height: 35px;
}

.comparison-symbol {
    font-size: 3rem;
    color: #01aebe;
}

.symbol {
    font-size: 1.5rem;
    color: #01aebe;
}

.navigation-drawer {
    width: 17% !important;
    min-width: 200px;
    box-shadow: 0 3px 5px rgb(0 0 0 / 10%);
}

.v-list-item {
    color: #01aebe !important;
    width: 95%;
    margin-top: 5%;
}

.list-item {
    display: flex;
    color: black !important;
    font-family: "Poppins";
}

.active-class {
    background-color: #f5f8fc !important;
    min-width: 160px !important;
}

.name-wrapper {
    background-color: #f5f8fc !important;
}

.list {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-top: 2rem;
}

.name {
    width: 100%;
    color: black;
    font-size: 1.35rem;
    font-family: "Poppins-Bold";
}

.menu-img {
    margin-right: 1em;
    width: 24px;
    height: 24px;
}
</style>
